import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes, faFilter, faFilePdf, faDownload, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { apiImage } from "../../services/Api";
import * as XLSX from 'xlsx';

// ─── Modal Generico para Selección (EPS, Usuarios, etc.) ──────────────────────
const ModalSelect = ({ open, onClose, title, onSelect, idMenu }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) {
            setSearchTerm('');
            fetchData(1, '');
        }
    }, [open]);

    const fetchData = async (page = 1, search = '') => {
        setLoading(true);
        const u = localStorage.getItem('idusuario') || 1;
        const formData = new FormData();

        if (search) {
            formData.append('BUS_nombre', search);
            formData.append('BUS_razon_social', search);
            formData.append('BUS_id', search);
        }

        try {
            if (idMenu === 'atenciones') {
                const res = await authAxios.get(`master/atenciones-search?buscar_palabra=${search || ''}&page=${page}`);
                const dataArray = res.data.data.data || res.data.data || [];
                setItems(dataArray);
            } else if (idMenu === 55 || idMenu === 'estado_paciente' || idMenu === 'remision') {
                const reqData = idMenu === 55
                    ? { tabla: "users", id: "id", nombre: "nombre", opcional: "apellido" }
                    : idMenu === 'estado_paciente'
                        ? { tabla: "programa", id: "id", nombre: "nombre" }
                        : { tabla: "remision", id: "id", nombre: "nombre" };
                const res = await authAxios.post(`master/relacion`, reqData);
                let dataArray = Array.isArray(res.data) ? res.data : [];
                if (search) {
                    const s = search.toLowerCase();
                    dataArray = dataArray.filter(i =>
                        String(i.nombre || i.nombre_estado || '').toLowerCase().includes(s) ||
                        String(i.id) === search
                    );
                }
                setItems(dataArray);
            } else {
                const res = await authAxios.post(`master/index/${idMenu}/${u}?page=${page}`, formData);
                if (res.data?.data?.data) {
                    setItems(res.data.data.data);
                } else if (res.data?.data) {
                    setItems(res.data.data);
                }
            }
        } catch (e) {
            console.error("Error cargando modal:", e);
        }
        setLoading(false);
    };

    const handleSearch = () => {
        fetchData(1, searchTerm);
    };

    if (!open) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header bg-primary text-white py-2">
                        <h5 className="modal-title m-0" style={{ fontSize: '1.1rem' }}>{title}</h5>
                        <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
                    </div>
                    <div className="modal-body p-3">
                        <div className="input-group mb-3">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Buscar..."
                                value={searchTerm}
                                onChange={e => {
                                    setSearchTerm(e.target.value);
                                    if (e.target.value.length > 2 || e.target.value === '') {
                                        fetchData(1, e.target.value);
                                    }
                                }}
                            />
                            <button className="btn btn-primary btn-sm" onClick={handleSearch}>
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                        </div>
                        {loading ? (
                            <div className="text-center py-4"><i>Cargando datos...</i></div>
                        ) : (
                            <div className="table-responsive">
                                <table className="table table-hover table-sm table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            <th>ID</th>
                                            <th>Detalle</th>
                                            <th className="text-center">Acción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.length === 0 ? (
                                            <tr><td colSpan="3" className="text-center py-3">No hay registros</td></tr>
                                        ) : (
                                            items.map(it => {
                                                const itemName = it.nombre || it.razon_social || it.name || it.descripcion || "-";
                                                return (
                                                    <tr key={it.id}>
                                                        <td>{it.id}</td>
                                                        <td>{itemName} {it.apellido ? it.apellido : ''}</td>
                                                        <td className="text-center">
                                                            <button
                                                                className="btn btn-success btn-sm"
                                                                onClick={() => {
                                                                    onSelect({ id: it.id, nombre: `${itemName} ${it.apellido || ''}`.trim() });
                                                                    onClose();
                                                                }}
                                                            >
                                                                Seleccionar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
};

// ─── Componente Principal Reportes1 ──────────────────────────────────────────
const Reportes1 = () => {
    // Datos de API
    const [ordenesOriginales, setOrdenesOriginales] = useState([]);
    const [ordenesFiltradas, setOrdenesFiltradas] = useState([]);
    const [loading, setLoading] = useState(false);

    // Estados para los filtros
    const [filtroId, setFiltroId] = useState('');
    const [filtroAutorizacion, setFiltroAutorizacion] = useState('');
    const [filtroPaciente, setFiltroPaciente] = useState('');
    const [filtroEps, setFiltroEps] = useState('');
    const [filtroEpsName, setFiltroEpsName] = useState('');
    const [filtroAsignado, setFiltroAsignado] = useState('');
    const [filtroAsignadoName, setFiltroAsignadoName] = useState('');
    const [filtroEstadoPacienteId, setFiltroEstadoPacienteId] = useState('');
    const [filtroEstadoPacienteName, setFiltroEstadoPacienteName] = useState('');
    const [filtroCodigoAtencion, setFiltroCodigoAtencion] = useState('');
    const [filtroCodigoAtencionName, setFiltroCodigoAtencionName] = useState('');
    const [filtroRemitido, setFiltroRemitido] = useState('');
    const [filtroRemitidoName, setFiltroRemitidoName] = useState('');
    const [filtroEstado, setFiltroEstado] = useState('Todas');
    const [filtroFactura, setFiltroFactura] = useState('Todas');
    const [filtroLiquidacion, setFiltroLiquidacion] = useState('Todas');
    const [filtroArchivo, setFiltroArchivo] = useState('Todas');
    const [filtroNumeroArchivo, setFiltroNumeroArchivo] = useState('');
    const [filtroDescargado, setFiltroDescargado] = useState('Todos');
    const [filtroFirmas, setFiltroFirmas] = useState('Todas');
    const [filtroEvolucionada, setFiltroEvolucionada] = useState('Todas');

    const fileInputRef = useRef(null);
    const fileInputRefAutorizaciones = useRef(null);

    const getPrimerDiaMesAnterior = () => {
        const d = new Date();
        d.setMonth(d.getMonth() - 1);
        d.setDate(1);
        return d.toISOString().split('T')[0];
    };
    const getUltimoDiaMesActual = () => {
        const d = new Date();
        d.setMonth(d.getMonth() + 1);
        d.setDate(0);
        return d.toISOString().split('T')[0];
    };

    const [fechaDesde, setFechaDesde] = useState(getPrimerDiaMesAnterior());
    const [fechaHasta, setFechaHasta] = useState(getUltimoDiaMesActual());
    const [filtroAtencion, setFiltroAtencion] = useState('');

    // Estados para modales
    const [modalEpsOpen, setModalEpsOpen] = useState(false);
    const [modalUserOpen, setModalUserOpen] = useState(false);
    const [modalEstadoPacienteOpen, setModalEstadoPacienteOpen] = useState(false);
    const [modalAtencionOpen, setModalAtencionOpen] = useState(false);
    const [modalRemitidoOpen, setModalRemitidoOpen] = useState(false);

    // Cargar datos iniciales
    useEffect(() => {
        cargarOrdenes();
    }, []);

    const cargarOrdenes = async () => {
        setLoading(true);
        try {
            const response = await authAxios.post('ordenes/reportes_1', {
                fecha_inicial: fechaDesde,
                fecha_final: fechaHasta,
                eps: filtroEps,
                estado_paciente: filtroEstadoPacienteId || filtroEstadoPacienteName,
                codigo_atencion: filtroCodigoAtencion,
                estado_archivo: filtroArchivo !== 'Todas' ? filtroArchivo : undefined
            });
            if (response.data?.Status) {
                setOrdenesOriginales(response.data.ordenes);
                setOrdenesFiltradas(response.data.ordenes);
            }
        } catch (error) {
            Swal.fire('Error', 'No se pudieron cargar las órdenes para el reporte', 'error');
            console.error(error);
        }
        setLoading(false);
    };

    useEffect(() => {
        aplicarFiltros();
    }, [
        filtroId, filtroAutorizacion, filtroPaciente, filtroEps,
        filtroAsignado, filtroEstado, filtroFactura, filtroLiquidacion,
        filtroAtencion, filtroEstadoPacienteId, filtroEstadoPacienteName, filtroCodigoAtencion, filtroArchivo, filtroNumeroArchivo, filtroRemitido, filtroDescargado, filtroFirmas, filtroEvolucionada, ordenesOriginales
    ]);

    const aplicarFiltros = () => {
        let result = [...ordenesOriginales];

        if (filtroId) {
            result = result.filter(o => String(o.id) === String(filtroId));
        }
        if (filtroAutorizacion) {
            result = result.filter(o => String(o.orden_externa || '') === String(filtroAutorizacion));
        }
        if (filtroPaciente) {
            const searchTerms = filtroPaciente.toLowerCase();
            result = result.filter(o =>
                String(o.cedula || '').toLowerCase().includes(searchTerms) ||
                String(o.nombre || '').toLowerCase().includes(searchTerms) ||
                String(`${o.nombre} ${o.apellido} ${o.segundo_apellido}`).toLowerCase().includes(searchTerms)
            );
        }
        if (filtroEps) {
            result = result.filter(o => String(o.eps) === String(filtroEps));
        }
        if (filtroAsignado) {
            result = result.filter(o => String(o.asignado) === String(filtroAsignado));
        }
        if (filtroRemitido) {
            result = result.filter(o => String(o.remitir) === String(filtroRemitido));
        }
        if (filtroAtencion) {
            const searchTerms = filtroAtencion.toLowerCase();
            result = result.filter(o =>
                String(o.atencion_nombre || '').toLowerCase().includes(searchTerms) ||
                String(o.codigo || '').toLowerCase().includes(searchTerms)
            );
        }
        if (filtroEstadoPacienteId) {
            result = result.filter(o => 
                String(o.tipo_paciente || '') === String(filtroEstadoPacienteId) ||
                String(o.estado_paciente_prog || '').toLowerCase() === String(filtroEstadoPacienteName || '').toLowerCase() ||
                String(o.estado_paciente || '').toLowerCase() === String(filtroEstadoPacienteName || '').toLowerCase()
            );
        } else if (filtroEstadoPacienteName) {
            result = result.filter(o => 
                String(o.estado_paciente_prog || '').toLowerCase() === String(filtroEstadoPacienteName).toLowerCase() ||
                String(o.estado_paciente || '').toLowerCase() === String(filtroEstadoPacienteName).toLowerCase()
            );
        }
        if (filtroCodigoAtencion) {
            result = result.filter(o => String(o.codigo) === String(filtroCodigoAtencion));
        }
        if (filtroNumeroArchivo) {
            result = result.filter(o => String(o.archivo || '') === String(filtroNumeroArchivo));
        }

        // Filtros Selects
        if (filtroEstado !== 'Todas') {
            if (filtroEstado === 'No iniciadas') {
                result = result.filter(o => Number(o.porcentaje) === 0);
            } else if (filtroEstado === 'En proceso') {
                result = result.filter(o => Number(o.porcentaje) > 0 && Number(o.porcentaje) < 99);
            } else if (filtroEstado === 'Completadas') {
                result = result.filter(o => Number(o.porcentaje) >= 99);
            }
        }

        if (filtroFactura !== 'Todas') {
            if (filtroFactura === 'Facturadas') {
                result = result.filter(o => Number(o.factura) !== 0);
            } else if (filtroFactura === 'No facturadas') {
                result = result.filter(o => Number(o.factura) === 0);
            }
        }

        if (filtroLiquidacion !== 'Todas') {
            if (filtroLiquidacion === 'Liquidadas') {
                result = result.filter(o => Number(o.liquidacion) === 1);
            } else if (filtroLiquidacion === 'No Liquidadas') {
                result = result.filter(o => Number(o.liquidacion) === 0);
            }
        }

        if (filtroArchivo !== 'Todas') {
            if (filtroArchivo === 'No iniciadas') {
                result = result.filter(o => Number(o.porcentaje_general || 0) === 0);
            } else if (filtroArchivo === 'En proceso') {
                result = result.filter(o => Number(o.porcentaje_general || 0) > 0 && Number(o.porcentaje_general || 0) < 100);
            } else if (filtroArchivo === 'Completadas') {
                result = result.filter(o => Number(o.porcentaje_general || 0) >= 100);
            }
        }

        if (filtroDescargado !== 'Todos') {
            if (filtroDescargado === 'Si') {
                result = result.filter(o => Number(o.descargado) === 1);
            } else if (filtroDescargado === 'No') {
                result = result.filter(o => Number(o.descargado) !== 1);
            }
        }

        if (filtroFirmas !== 'Todas') {
            if (filtroFirmas === 'Completas') {
                result = result.filter(o => o.firmas_completadas || (o.firmas_count >= (o.total_firmas || o.cantidad || 1) && o.firmas_count > 0));
            } else if (filtroFirmas === 'Incompletas') {
                result = result.filter(o => !o.firmas_completadas);
            }
        }

        if (filtroEvolucionada !== 'Todas') {
            if (filtroEvolucionada === 'Si') {
                result = result.filter(o => o.evolucionada || (o.evoluciones_count && o.evoluciones_count > 0));
            } else if (filtroEvolucionada === 'No') {
                result = result.filter(o => !o.evolucionada && (!o.evoluciones_count || o.evoluciones_count === 0));
            }
        }

        setOrdenesFiltradas(result);
    };

    const limpiarFiltros = () => {
        setFiltroId('');
        setFiltroAutorizacion('');
        setFiltroPaciente('');
        setFiltroEps('');
        setFiltroEpsName('');
        setFiltroAsignado('');
        setFiltroAsignadoName('');
        setFiltroRemitido('');
        setFiltroRemitidoName('');
        setFiltroEstado('Todas');
        setFiltroFactura('Todas');
        setFiltroLiquidacion('Todas');
        setFiltroArchivo('Todas');
        setFiltroNumeroArchivo('');
        setFiltroAtencion('');
        setFiltroEstadoPacienteId('');
        setFiltroEstadoPacienteName('');
        setFiltroCodigoAtencion('');
        setFiltroCodigoAtencionName('');
        setFiltroDescargado('Todos');
        setFiltroFirmas('Todas');
        setFiltroEvolucionada('Todas');
    };

    const exportarExcel = async () => {
        if (ordenesFiltradas.length === 0) {
            Swal.fire('Atención', 'No hay datos para exportar', 'warning');
            return;
        }

        let excelData = [];
        ordenesFiltradas.forEach(ord => {
            const nombreCompleto = `${ord.nombre} ${ord.segundo_nombre || ''} ${ord.apellido} ${ord.segundo_apellido || ''}`.trim();
            const diagCompleto = ord.diagnostico_nombre ? `${ord.diagnostico_principal} - ${ord.diagnostico_nombre}` : (ord.diagnostico_principal || '-');
            
            excelData.push({
                "ID Orden": ord.id,
                "Autorización": ord.orden_externa || '-',
                "ID Archivo": ord.archivo || '-',
                "Progreso Archivo (%)": ord.porcentaje_general || 0,
                "Fecha de Ingreso": ord.fecha_inicial,
                "Fecha Inicio": ord.fecha_inicio || '-',
                "Fecha Fin": ord.fecha_fin || '-',
                "Tipo Doc": ord.tipo_documento || ord.tipo_documento_nombre || '-',
                "Cédula": ord.cedula,
                "Nombre Completo": nombreCompleto,
                "Teléfono": ord.telefono || '-',
                "Dirección": ord.direccion || '-',
                "Barrio": ord.barrio || '-',
                "Edad": ord.edad || '-',
                "Fecha Nacimiento": ord.fecha_nacimiento || '-',
                "Género": ord.genero || ord.genero_nombre || '-',
                "EPS": ord.eps_nombre || ord.eps || '-',
                "Estado Paciente (Programa)": ord.estado_paciente_prog || '-',
                "Régimen": ord.regimen_nombre || '-',
                "Remitido": ord.remitido_nombre || '-',
                "Diagnóstico Principal": diagCompleto,
                "Código Atención": ord.codigo || '-',
                "Código Sura": ord.codigo_sura || '-',
                "Atención Detalle": ord.atencion_nombre || '-',
                "Cantidad": ord.cantidad,
                "Profesional Asignado": ord.nombre_asignado || '-',
                "Progreso (%)": ord.porcentaje,
                "Firmas": ord.firmas_texto || `${ord.firmas_count || 0} de ${ord.total_firmas || ord.cantidad || 0}`,
                "Evolucionada": (ord.evolucionada || (ord.evoluciones_count && ord.evoluciones_count > 0)) ? `Sí${ord.evoluciones_count > 1 ? ` (${ord.evoluciones_count})` : ''}` : 'No',
                "Facturación": Number(ord.factura) !== 0 ? 'Sí (Facturada)' : 'No (Sin facturar)',
                "Liquidación": Number(ord.liquidacion) === 1 ? 'Sí (Liquidada)' : 'No (Sin liquidar)',
                "Estado Orden": ord.estado_orden_nombre || '-',
                "Revisado": ord.revisado || '-',
                "Consentimiento": ord.consentimiento ? 'Cargado' : 'Sin Cargar',
                "Valor Atención": ord.valor_atencion || '0',
                "Valor Copago": ord.valor_copago || '0',
                "Notas": ord.notas || '-',
                "Obs. Internas": ord.obs_interna || '-',
                "Descargado": Number(ord.descargado) === 1 ? 'Sí' : 'No',
                "Fecha Descarga": ord.fecha_descarga || '-'
            });
        });

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Reporte_Completo");
        XLSX.writeFile(workbook, `Reporte_Ordenes_Pacientes_${new Date().toISOString().split('T')[0]}.xlsx`);

    };

    const triggerUploadExcel = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const triggerUploadAutorizaciones = () => {
        if (fileInputRefAutorizaciones.current) {
            fileInputRefAutorizaciones.current.click();
        }
    };

    const handleFileUploadAutorizaciones = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (evt) => {
            try {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                
                let actualizaciones = [];
                for (let i = 1; i < data.length; i++) {
                    const row = data[i];
                    if (row && row.length >= 2) {
                        const id = row[0];
                        const autorizacion = row[1];
                        if (id) {
                            actualizaciones.push({ id: id, autorizacion: autorizacion || '' });
                        }
                    }
                }

                if (actualizaciones.length === 0) {
                    Swal.fire('Error', 'No se encontraron datos válidos en el archivo Excel. Recuerda que la Columna 1 debe ser ID Orden y la Columna 2 la Autorización.', 'error');
                    return;
                }

                Swal.fire({
                    title: 'Procesando...',
                    text: 'Actualizando autorizaciones',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                await authAxios.post('ordenes/actualizar_autorizaciones', { actualizaciones });
                Swal.fire('Éxito', `Se actualizaron ${actualizaciones.length} autorizaciones de forma masiva.`, 'success');
                cargarOrdenes();
            } catch (error) {
                Swal.fire('Error', 'Hubo un error al procesar el archivo Excel o actualizar el servidor.', 'error');
                console.error(error);
            }
        };
        reader.readAsBinaryString(file);
        e.target.value = ''; // reset
    };

    const handleFileUploadExcel = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async (evt) => {
            try {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'binary' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_json(ws);
                
                let ids = [];
                data.forEach(row => {
                    const id = row['ID Orden'] || row['ID_Orden'] || row['ID'] || row['id'] || row['Id Orden'] || row['id orden'];
                    if(id) {
                        ids.push(id);
                    }
                });

                if (ids.length === 0) {
                    Swal.fire('Error', 'No se encontraron IDs de orden válidos en el archivo Excel. Asegúrate de que la primera columna se llame "ID Orden".', 'error');
                    return;
                }

                Swal.fire({
                    title: 'Procesando...',
                    text: 'Marcando órdenes como descargadas',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                await authAxios.post('ordenes/marcar_descargados', { ids });
                Swal.fire('Éxito', `Se marcaron ${ids.length} órdenes como descargadas.`, 'success');
                cargarOrdenes();
            } catch (error) {
                Swal.fire('Error', 'Hubo un error al procesar el archivo Excel o actualizar el servidor.', 'error');
                console.error(error);
            }
        };
        reader.readAsBinaryString(file);
        e.target.value = ''; // reset

    };

    const getEstadoBadge = (porcentaje) => {
        const p = Number(porcentaje);
        if (p === 0) return <span className="badge bg-secondary p-2">0% - No Iniciada</span>;
        if (p >= 99) return <span className="badge bg-success p-2">{p}% - Completada</span>;
        return <span className="badge bg-warning text-dark p-2">{p}% - En Proceso</span>;
    };

    const verOrden = (id, tabla) => {
        window.localStorage.setItem("Archivo", tabla);
        window.localStorage.setItem("TablaId", id);
    };

    const verDetalle = (id, tabla) => {
        window.localStorage.setItem("Archivo", id);
        window.localStorage.setItem("TablaId", tabla);
    };

    return (
        <div className="content-wrapper">
            <div className="content">
                <div className="container-fluid pt-4">

                    {/* Tarjeta de Filtros */}
                    <div className="card shadow-sm mb-4" style={{ borderRadius: '10px' }}>
                        <div className="card-header bg-white border-bottom">
                            <h4 className="card-title text-primary m-0" style={{ fontWeight: '600' }}>
                                <FontAwesomeIcon icon={faFilter} className="me-2" />
                                Filtros de Búsqueda para Reporte 1
                            </h4>
                        </div>
                        <div className="card-body bg-light">
                            <div className="row g-3">
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Orden Interna</label>
                                    <input type="text" className="form-control form-control-sm" value={filtroId} onChange={e => setFiltroId(e.target.value)} placeholder="ID Int" />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Orden Externa</label>
                                    <input type="text" className="form-control form-control-sm" value={filtroAutorizacion} onChange={e => setFiltroAutorizacion(e.target.value)} placeholder="Autorización" />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">N° Archivo</label>
                                    <input type="text" className="form-control form-control-sm" value={filtroNumeroArchivo} onChange={e => setFiltroNumeroArchivo(e.target.value)} placeholder="N° Archivo" />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Paciente (Céd/Nom)</label>
                                    <input type="text" className="form-control form-control-sm" value={filtroPaciente} onChange={e => setFiltroPaciente(e.target.value)} placeholder="Cédula o Nombre" />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Fecha Desde</label>
                                    <input type="date" className="form-control form-control-sm" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} />
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Fecha Hasta</label>
                                    <input type="date" className="form-control form-control-sm" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted small fw-bold">Atención (Código)</label>
                                    <div className="input-group input-group-sm">
                                        <input type="text" className="form-control bg-white" value={filtroCodigoAtencionName} placeholder="- Seleccione Atención -" readOnly />
                                        {filtroCodigoAtencion && (
                                            <button className="btn btn-outline-danger" type="button" onClick={() => { setFiltroCodigoAtencion(''); setFiltroCodigoAtencionName(''); }}>
                                                <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                        )}
                                        <button className="btn btn-primary" type="button" onClick={() => setModalAtencionOpen(true)}>
                                            <FontAwesomeIcon icon={faSearch} /> Buscar
                                        </button>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label text-muted small fw-bold">Empresa (EPS)</label>
                                    <div className="input-group input-group-sm">
                                        <input type="text" className="form-control bg-white" value={filtroEpsName} placeholder="- Seleccione EPS -" readOnly />
                                        {filtroEps && (
                                            <button className="btn btn-outline-danger" type="button" onClick={() => { setFiltroEps(''); setFiltroEpsName(''); }}>
                                                <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                        )}
                                        <button className="btn btn-primary" type="button" onClick={() => setModalEpsOpen(true)}>
                                            <FontAwesomeIcon icon={faSearch} /> Buscar
                                        </button>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted small fw-bold">Remitido</label>
                                    <div className="input-group input-group-sm">
                                        <input type="text" className="form-control bg-white" value={filtroRemitidoName} placeholder="- Seleccione Remitido -" readOnly />
                                        {filtroRemitido && (
                                            <button className="btn btn-outline-danger" type="button" onClick={() => { setFiltroRemitido(''); setFiltroRemitidoName(''); }}>
                                                <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                        )}
                                        <button className="btn btn-primary" type="button" onClick={() => setModalRemitidoOpen(true)}>
                                            <FontAwesomeIcon icon={faSearch} /> Buscar
                                        </button>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted small fw-bold">Usuario Asignado</label>
                                    <div className="input-group input-group-sm">
                                        <input type="text" className="form-control bg-white" value={filtroAsignadoName} placeholder="- Asignado -" readOnly />
                                        {filtroAsignado && (
                                            <button className="btn btn-outline-danger" type="button" onClick={() => { setFiltroAsignado(''); setFiltroAsignadoName(''); }}>
                                                <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                        )}
                                        <button className="btn btn-secondary" type="button" onClick={() => setModalUserOpen(true)}>
                                            <FontAwesomeIcon icon={faSearch} /> Buscar
                                        </button>
                                    </div>
                                </div>

                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Estado de Orden</label>
                                    <select className="form-select form-select-sm" value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
                                        <option value="Todas">Todas</option>
                                        <option value="No iniciadas">No Iniciadas (0%)</option>
                                        <option value="En proceso">En Proceso (1-99%)</option>
                                        <option value="Completadas">Completadas (100%)</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Facturación</label>
                                    <select className="form-select form-select-sm" value={filtroFactura} onChange={e => setFiltroFactura(e.target.value)}>
                                        <option value="Todas">Todas</option>
                                        <option value="Facturadas">Sí Facturadas</option>
                                        <option value="No facturadas">No Facturadas</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Liquidación</label>
                                    <select className="form-select form-select-sm" value={filtroLiquidacion} onChange={e => setFiltroLiquidacion(e.target.value)}>
                                        <option value="Todas">Todas</option>
                                        <option value="Liquidadas">Sí Liquidadas</option>
                                        <option value="No Liquidadas">No Liquidadas</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Estado Archivo</label>
                                    <select className="form-select form-select-sm" value={filtroArchivo} onChange={e => setFiltroArchivo(e.target.value)}>
                                        <option value="Todas">Todas</option>
                                        <option value="No iniciadas">No Iniciadas (0%)</option>
                                        <option value="En proceso">En Proceso (1-99%)</option>
                                        <option value="Completadas">Completadas (100%)</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Descargado</label>
                                    <select className="form-select form-select-sm" value={filtroDescargado} onChange={e => setFiltroDescargado(e.target.value)}>
                                        <option value="Todos">Todos</option>
                                        <option value="Si">Sí</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Firmas</label>
                                    <select className="form-select form-select-sm" value={filtroFirmas} onChange={e => setFiltroFirmas(e.target.value)}>
                                        <option value="Todas">Todas</option>
                                        <option value="Completas">Completas</option>
                                        <option value="Incompletas">Incompletas</option>
                                    </select>
                                </div>
                                <div className="col-md-2">
                                    <label className="form-label text-muted small fw-bold">Evolucionada</label>
                                    <select className="form-select form-select-sm" value={filtroEvolucionada} onChange={e => setFiltroEvolucionada(e.target.value)}>
                                        <option value="Todas">Todas</option>
                                        <option value="Si">Sí</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label text-muted small fw-bold">Estado Paciente</label>
                                    <div className="input-group input-group-sm">
                                        <input type="text" className="form-control bg-white" value={filtroEstadoPacienteName} placeholder="- Seleccione -" readOnly />
                                        {filtroEstadoPacienteName && (
                                            <button className="btn btn-outline-danger" type="button" onClick={() => { setFiltroEstadoPacienteName(''); setFiltroEstadoPacienteId(''); }}>
                                                <FontAwesomeIcon icon={faTimes} />
                                            </button>
                                        )}
                                        <button className="btn btn-secondary" type="button" onClick={() => setModalEstadoPacienteOpen(true)}>
                                            <FontAwesomeIcon icon={faSearch} /> Buscar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 text-end">
                                    <button className="btn btn-outline-secondary btn-sm" onClick={limpiarFiltros}>
                                        <FontAwesomeIcon icon={faTimes} className="me-1" /> Limpiar Filtros
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Tabla de Resultados */}
                    <div className="card shadow-sm" style={{ borderRadius: '10px' }}>
                        <div className="card-header bg-white d-flex justify-content-between align-items-center">
                            <h5 className="card-title m-0 fw-bold">Reporte 1 - Listado de Órdenes ({ordenesFiltradas.length})</h5>
                            <div>
                                <input 
                                    type="file" 
                                    accept=".xlsx, .xls" 
                                    ref={fileInputRef} 
                                    style={{ display: 'none' }} 
                                    onChange={handleFileUploadExcel} 
                                />
                                <input 
                                    type="file" 
                                    accept=".xlsx, .xls" 
                                    ref={fileInputRefAutorizaciones} 
                                    style={{ display: 'none' }} 
                                    onChange={handleFileUploadAutorizaciones} 
                                />
                                <button className="btn btn-info btn-sm me-2 text-white fw-bold" onClick={triggerUploadAutorizaciones} disabled={loading}>
                                    <FontAwesomeIcon icon={faDownload} /> Cargar Excel (Autorizaciones)
                                </button>
                                <button className="btn btn-warning btn-sm me-2 text-dark fw-bold" onClick={triggerUploadExcel} disabled={loading}>
                                    <FontAwesomeIcon icon={faDownload} /> Cargar Excel (Descargados)
                                </button>
                                <button className="btn btn-success btn-sm me-2" onClick={exportarExcel} disabled={loading}>
                                    <FontAwesomeIcon icon={faDownload} /> Exportar Excel
                                </button>
                                <button className="btn btn-primary btn-sm" onClick={cargarOrdenes} disabled={loading}>
                                    {loading ? 'Cargando...' : 'Obtener del Rango'}
                                </button>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover table-striped align-middle m-0" style={{ fontSize: '0.9rem' }}>
                                    <thead className="table-light">
                                        <tr>
                                            <th>ID Internal</th>
                                            <th>Archivo</th>
                                            <th className="text-center text-nowrap" style={{ minWidth: "105px" }}>Firmas</th>
                                            <th className="text-center text-nowrap" style={{ minWidth: "110px" }}>Evolucionada</th>
                                            <th>Cód. / Autorización</th>
                                            <th>Fecha Ingreso</th>
                                            <th>Fecha Inicio</th>
                                            <th>Fecha Fin</th>
                                            <th>Paciente (CC y Nombres)</th>
                                            <th>Teléfono</th>
                                            <th>Dirección</th>
                                            <th>Barrio</th>
                                            <th>Empresa / EPS</th>
                                            <th>Remitido</th>
                                            <th>Atención</th>
                                            <th className="text-center">Cant.</th>
                                            <th className="text-center">Profesional.</th>
                                            <th className="text-center">Estado Orden</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ordenesFiltradas.length === 0 ? (
                                            <tr>
                                                <td colSpan="18" className="text-center py-5">
                                                    {loading ? <div>Cargando datos...</div> : <div className="text-muted"><FontAwesomeIcon icon={faSearch} size="2x" className="mb-2 d-block mx-auto" /> No se encontraron resultados con los filtros actuales.</div>}
                                                </td>
                                            </tr>
                                        ) : (
                                            ordenesFiltradas.map((ord, idx) => (
                                                <tr key={idx}>
                                                    <td className="fw-bold">
                                                        <Link
                                                            className="btn btn-success btn-sm fw-bold"
                                                            to={"/pages/orden/Dubai"}
                                                            target="_blank"
                                                            onClick={() => verOrden(ord.archivo, 200)}
                                                        >
                                                            #{ord.id}
                                                        </Link>
                                                        <div className="mt-1" style={{fontSize: '0.8rem'}}>
                                                            {Number(ord.descargado) === 1 ? (
                                                                <span className="text-success fw-normal"><FontAwesomeIcon icon={faCheckCircle} /> Desc. {ord.fecha_descarga}</span>
                                                            ) : (
                                                                <span className="text-secondary fw-normal">No descargado</span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="fw-bold d-block text-secondary">#{ord.archivo || '-'}</span>
                                                        {getEstadoBadge(ord.porcentaje_general || 0)}
                                                    </td>
                                                    <td className="text-center align-middle text-nowrap">
                                                        <span
                                                            className={`badge ${ord.firmas_completadas ? 'bg-success' : 'bg-danger'} fw-bold px-2 py-1`}
                                                            style={{ fontSize: '0.85rem' }}
                                                            title={ord.firmas_completadas ? 'Firmas completas' : `Faltan ${ord.faltan_firmas || 0} firmas`}
                                                        >
                                                            {`${ord.firmas_count || 0} de ${ord.total_firmas || ord.cantidad || 0}`}
                                                        </span>
                                                    </td>
                                                    <td className="text-center align-middle text-nowrap">
                                                        {ord.evolucionada || (ord.evoluciones_count && ord.evoluciones_count > 0) ? (
                                                            <span className="badge bg-success fw-bold px-2 py-1" style={{ fontSize: '0.85rem' }}>
                                                                Sí {ord.evoluciones_count > 1 ? `(${ord.evoluciones_count})` : ''}
                                                            </span>
                                                        ) : (
                                                            <span className="badge bg-danger fw-bold px-2 py-1" style={{ fontSize: '0.85rem' }}>
                                                                No
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td>Aut: {ord.orden_externa || '-'}</td>
                                                    <td>{ord.fecha_inicial}</td>
                                                    <td className="text-primary fw-bold">{ord.fecha_inicio || '-'}</td>
                                                    <td className="text-danger fw-bold">{ord.fecha_fin || '-'}</td>
                                                    <td>
                                                        <span className="d-block fw-bold">{ord.cedula}</span>
                                                        <Link
                                                            className="text-decoration-none text-secondary fw-bold"
                                                            to={"/pages/detalle/Dubai"}
                                                            target="_blank"
                                                            onClick={() => verDetalle(ord.paciente, 168)}
                                                        >
                                                            {`${ord.nombre} ${ord.segundo_nombre || ''} ${ord.apellido} ${ord.segundo_apellido || ''}`}
                                                        </Link>
                                                        {(ord.estado_paciente || ord.estado_paciente_prog) && (
                                                            <div className="mt-1">
                                                                <span className="badge bg-secondary">
                                                                    {ord.estado_paciente || ord.estado_paciente_prog}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td>{ord.telefono || '-'}</td>
                                                    <td>{ord.direccion || '-'}</td>
                                                    <td>{ord.barrio || '-'}</td>
                                                    <td>
                                                        <span className="d-block text-truncate fw-bold" style={{ maxWidth: '150px' }} title={ord.eps_nombre || ord.eps}>
                                                            {ord.eps_nombre || '-'}
                                                        </span>
                                                        <span className="badge bg-primary mt-1">RIPS: {ord.eps_rips || '-'}</span>
                                                    </td>
                                                    <td>
                                                        <span className="d-block text-truncate fw-bold" style={{ maxWidth: '150px' }} title={ord.remitido_nombre || ord.remitir}>
                                                            {ord.remitido_nombre || '-'}
                                                        </span>
                                                    </td>
                                                    <td style={{ maxWidth: '250px' }}>
                                                        <span className="text-wrap d-block text-truncate" title={ord.atencion_nombre}>
                                                            {ord.atencion_nombre}
                                                        </span>
                                                        <span className="badge bg-info mt-1 d-block">CUPS: {ord.codigo}</span>
                                                        {ord.codigo_sura && <span className="badge bg-secondary mt-1 d-block">SURA: {ord.codigo_sura}</span>}
                                                    </td>
                                                    <td className="text-center">{ord.cantidad}</td>
                                                    <td className="text-center">{ord.nombre_asignado}</td>
                                                    <td className="text-center">
                                                        {getEstadoBadge(ord.porcentaje)}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modales */}
            <ModalSelect
                open={modalEpsOpen}
                onClose={() => setModalEpsOpen(false)}
                title="Seleccionar Empresa (EPS)"
                idMenu={179}
                onSelect={(item) => {
                    setFiltroEps(item.id);
                    setFiltroEpsName(item.nombre);
                }}
            />

            <ModalSelect
                open={modalUserOpen}
                onClose={() => setModalUserOpen(false)}
                title="Seleccionar Usuario Asignado"
                idMenu={55}
                onSelect={(item) => {
                    setFiltroAsignado(item.id);
                    setFiltroAsignadoName(item.nombre);
                }}
            />

            <ModalSelect
                open={modalEstadoPacienteOpen}
                onClose={() => setModalEstadoPacienteOpen(false)}
                title="Seleccionar Estado Paciente"
                idMenu="estado_paciente"
                onSelect={(item) => {
                    setFiltroEstadoPacienteId(item.id);
                    setFiltroEstadoPacienteName(item.nombre);
                }}
            />

            <ModalSelect
                open={modalAtencionOpen}
                onClose={() => setModalAtencionOpen(false)}
                title="Seleccionar Atención"
                idMenu="atenciones"
                onSelect={(item) => {
                    setFiltroCodigoAtencion(item.id);
                    setFiltroCodigoAtencionName(item.nombre);
                }}
            />

            <ModalSelect
                open={modalRemitidoOpen}
                onClose={() => setModalRemitidoOpen(false)}
                title="Seleccionar Remitido"
                idMenu="remision"
                onSelect={(item) => {
                    setFiltroRemitido(item.id);
                    setFiltroRemitidoName(item.nombre);
                }}
            />

        </div>
    );
};

export default Reportes1;
